import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHouseMeterStatuses = async () => {
  return await request.get(
    `/Meter/house_meter_statuses`,
    {},
    'При загрузке статусов ОДПУ произошла ошибка'
  );
};

export const useHouseMeterStatusesQuery = (options) =>
  useQuery(getQueryKeys.houseMeterStatuses(), getHouseMeterStatuses, {
    placeholderData: [],
    staleTime: Infinity,
    ...options,
  });
